import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from "axios";
import moment from "moment";
import { debounce } from "lodash";
import { withRouter } from 'react-router-dom'
import { CheckIcon } from '../Common/Buttons/Icons';
import { formatPhone } from '../../Helpers/PhoneHelper';
import { LoadingIcon, InLineLoading } from '../Common/Loading_Icon';
import { Trans } from 'react-i18next';

class MobileValidation extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.submitPhone = debounce(this.submitPhone.bind(this), 500);
        this.submitVerification = this.submitVerification.bind(this);
        this.pasteVerification = this.pasteVerification.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.mobilePhoneChange = this.mobilePhoneChange.bind(this);
        this.phoneChange = this.phoneChange.bind(this);
        this.formatNumber = this.formatNumber.bind(this);
        this.toggleFocus = this.toggleFocus.bind(this);
        this.goNext = this.goNext.bind(this);

        this.state = {
            phone_form: {country: "1", phone: ""},
            errors: {country: false, phone: false, activation: false},
            confirms: {phone: false, activation: false},
            activation_loading: false,
            phone_loading: false,
            focus: false
        };
    }

    componentDidMount() {        
        document.title = "Mobile Verification - FleetXPress"
        var self = this;

        axios.get('/ajax/phone/checkValidated')
        .then(function(response) {
            if (response?.data.phone_found) {
                self.props.history.push('/registrationsuccess')
            }
        })
        .catch(function(error) {

        })
    }
    
    submitPhone() {
        var self = this;

        if (this.state.confirms.activation) {
            showStatusMsg('You have already validated your phone number. Please press Next to complete the survey process.', 'success')
        } else if (this.state.phone_form.phone.length < 10 || ! /^\d+$/.test(this.state.phone_form.phone)) {
            var errors = this.state.errors
            errors["phone"] = true
            this.setState({
                errors: errors
            })
        } else {
            this.setState({
                phone_loading: true
            })

            axios.post("/ajax/phone/number", {country: this.state.phone_form.country, phone: this.state.phone_form.phone})
            .then(function(response) {
                if (response?.data.status === "pending") {
                    self.setState({
                        errors: {country: false, phone: false, activation: false},
                        confirms: {phone: true, activation: false},
                        activation_loading: false,
                        phone_loading: false
                    })
                } else {
                    self.setState({
                        errors: {country: true, phone: false, activation: false},
                        confirms: {phone: false, activation: false},
                        activation_loading: false,
                        phone_loading: false
                    })
                }

            })
            .catch(function(error) {
                self.setState({
                    errors: {country: true, phone: false, activation: false},
                    activation_loading: false
                })
            })
        }
    }

    submitVerification() {
        var self = this;
        var verification = ""
        for (var i = 0; i < 6; i++) {
            verification += document.getElementById("validation-" + i).value
        }

        if (this.state.phone_form.phone.length < 10 && this.state.confirms.phone) {
            var errors = this.state.errors;
            errors["phone"] = true
            this.setState({
                errors: errors
            })
        } else if (verification.length < 6) {
            var errors = this.state.errors;
            errors["activation"] = true
            this.setState({
                errors: errors
            })
        } else {
            this.setState({
                activation_loading: true
            })

            axios.post("/ajax/phone/verify", {country: this.state.phone_form.country, phone: this.state.phone_form.phone, verification: verification})
            .then(function(response) {
                if (response?.data.status === "approved" && response?.data.valid) {
                    self.setState({
                        activation_loading: false,
                        confirms: {phone: true, activation: true},
                        errors: {country: false, phone: false, activation: false},
                    })
                } else {
                    self.setState({
                        errors: {country: false, phone: false, activation: true},
                        confirms: {phone: true, activation: false},
                        activation_loading: false
                    })
                }
            })
            .catch(function(error) {
                self.setState({
                    errors: {country: false, phone: false, activation: true},
                    activation_loading: false
                })
            })
        }
    }

    pasteVerification(e) {
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        var phone_form = this.state.phone_form;
        phone_form[name] = value;

        this.setState({
            phone_form: phone_form
        });
    }

    mobilePhoneChange() {
        this.setState({
            errors: {country: false, phone: false, activation: false},
            confirms: {phone: false, activation: false},
            activation_loading: false,
        })

        for (var i = 0; i < 6; i++) {
            document.getElementById('validation-' + (i)).value = ""
        }

        var phone = document.getElementById('phone_input_mobile').value;
        phone = phone.replace(/\D/g,'')
        document.getElementById('phone_input_mobile').value = phone;

        var phone_form = this.state.phone_form
        phone_form['phone'] = phone;

        this.setState({
            phone_form: phone_form
        })
    }

    phoneChange(event) {
        event.preventDefault()
        this.setState({
            errors: {country: false, phone: false, activation: false},
            confirms: {phone: false, activation: false},
            activation_loading: false,
        })
        for (var i = 0; i < 6; i++) {
            document.getElementById('validation-' + (i)).value = ""
        }
        
        var current_phone = document.getElementById("phone_input").innerHTML
        current_phone = current_phone.replace(/\D/g, '')

        if (current_phone.length < 10) {
            if (isFinite(event.key)) {
                //Add number
                current_phone += event.key
            } 
        }

        if (event.keyCode === 8 || event.keyCode === 46) {
            //Backspace
            current_phone = current_phone.substring(0, current_phone.length - 1)
        } 

        var phone_form = this.state.phone_form
        phone_form['phone'] = current_phone

        this.setState({
            phone_form: phone_form
        })

        if (event.keyCode === 13 && current_phone.length === 10) {
            this.submitPhone();
        }
    }

    formatNumber(phone) {
        var phone_array = [<span className="phone_extra">(</span>]
        for (var i = 0; i < phone.length; i++) {
            if (i === 3) {
                phone_array.push(<span className="phone_extra">) </span>)
            }

            if (i === 6) {
                phone_array.push(<span className="phone_extra"> - </span>)
            }

            phone_array.push(<span className="phone_num">{phone[i]}</span>)
        } 

        while (phone_array.length < 13) {
            if (phone_array.length === 4) {
                phone_array.push(<span className="phone_extra">) </span>)
            }

            if (phone_array.length === 8) {
                phone_array.push(<span className="phone_extra"> - </span>)
            }

            phone_array.push(<span className="phone_underscore"> _ </span>)
        }

        return <>{phone_array}</>
    }

    handleActivationInput(event, index) {
        event.preventDefault();
        var self = this;

        if (event.keyCode === 8 || event.keyCode === 46) {
            document.getElementById('validation-' + (index)).value = ""
            if (index > 0) {
                document.getElementById('validation-' + (index - 1)).focus();
            } 
        } else if (event.keyCode !== 13 && isFinite(event.key)){
            document.getElementById('validation-' + index).value = event.key
        
            if (index < 5) {
                document.getElementById('validation-' + (index + 1)).focus();
            } else {
                this.submitVerification()
            }
        } else if (event.keyCode === 13) {
            this.submitVerification()
        } else if (event.keyCode == 229) { // android chrome only
            if (index < 5) {
                setTimeout(function(){
                    document.getElementById('validation-' + (index + 1)).focus();
                }, 50);
            } else {
                setTimeout(function(){
                    self.submitVerification();
                }, 100);
            }
        }
    }

    toggleFocus(focus) {
        this.setState({
            focus
        })
    }

    goNext() {
        var errors = this.state.errors;
        if (! this.state.confirms.phone) {
            errors["phone"] = true
            this.setState({
                errors: errors
            })
        } else if (! this.state.confirms.activation) {
            errors["activation"] = true
            this.setState({
                errors: errors
            })
        } else {
            this.props.history.push("/registrationsuccess")
        }
    }
    
    render() {
        return (
            <div className = "validation-container">
                <div className="registration-navbar">
                    <img src="images/dvms_logo.png" />
                </div>
                <div className="registration-card validation-card">
                    <div className="registration-header">
                        <div className="registration-heading">
                            <Trans>Your Mobile Number</Trans>
                        </div>
                        <div className="registration-subheading">
                            <Trans>Confirming your contact information will allow us to get in touch with you if plans change.</Trans>
                        </div>
                        <div className="registration-subheading medium">
                            <Trans>We will send you a one-time activation code.</Trans>
                        </div>
                    </div>
                    <div className="registration-main mobile-validation-main">
                        <div className="verification-area verification-left">
                            <div className="verification-image-container flex">
                                <img src="/images/icons/validation/Mobile_Hand.svg" className="verification-image"/>
                            </div>
                            <div className="verification-information">
                                <img src="/images/icons/validation/Security.svg" className="verification-security" />
                                <span className="verification-securitytext"><Trans>Your information will be secured utilizing 256-bit encryption for sending, receiving, and storing your information.</Trans></span>
                            </div>
                        </div>
                        <div className="verification-area">
                            <div className="verification-form">
                                <div className="verification-fields">
                                    <div className="verification-field">
                                        <div className="verification-label medium" style={{marginRight: 'auto'}}>
                                            <Trans>Country Code</Trans>
                                        </div>
                                        <div className="verification-select">
                                            <select style={{marginBottom: "0"}} className={this.state.errors.country ? "verification-error" : ""}>
                                                <option value="1" selected>+1 CA</option>
                                                <option value="1">+1 US</option>
                                            </select>
                                            {
                                                this.state.errors.country ?
                                                    <span style={{margin: "5px 0 0 0", fontSize: "8px", color: "red", display: "ruby-text"}}>*<Trans>This number is invalid. Please try another number.</Trans></span>
                                                :
                                                    null
                                            }
                                        </div>
                                        
                                    </div>
                                    <div className="verification-field" style={{marginLeft: 'auto'}}>
                                        <div className="verification-label medium">
                                            <Trans>Mobile Number</Trans>
                                        </div>
                                        <div contentEditable id="phone_input" className={"desktop verification-input" + (this.state.errors.phone ? " verification-error" : "")} onKeyDown={this.phoneChange}>
                                            {this.formatNumber(this.state.phone_form.phone)}
                                        </div>
                                        <input id="phone_input_mobile" onChange={this.mobilePhoneChange} className={"mobile verification-input" + (this.state.errors.phone ? " verification-error" : "")} type="tel" placeholder="(_ _ _)  _ _ _ - _ _ _ _"/>
                                        {
                                            this.state.errors.phone ?
                                                <span style={{margin: "5px 0 0 0", fontSize: "8px", color: "red", display: "ruby-text"}}><Trans>*This field is required.</Trans></span>
                                            :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="verification-button-container">
                                    <div className={"verification-button" + (this.state.confirms.phone ? " verification-success" : "")} onClick={this.submitPhone}>
                                        <span className="medium" style={{margin: 'auto'}}><Trans>{this.state.confirms.phone ? "Resend" : "Send"} Code</Trans></span>
                                        {
                                            this.state.confirms.phone ?
                                            <span style={{right: "0", position: "absolute", marginRight: "20px"}}>{CheckIcon('fill-green')}</span>
                                            :
                                                null
                                        }
                                        {
                                            this.state.phone_loading ? 
                                                InLineLoading("20px", "20px")
                                            :
                                                null
                                        }
                                    </div>
                                    {
                                        this.state.confirms.phone ? 
                                            <div className="verification-help help-primary">
                                                <Trans>*A 6-digit Activation Code has been sent to:</Trans> <span style={{fontSize: "10px"}} className="medium">{formatPhone(this.state.phone_form.phone)}</span>. <Trans>Please enter it below.</Trans>
                                            </div>
                                        :
                                            <div className="verification-help">
                                                <Trans>Message and data rates may apply to receive the activation code.</Trans>
                                            </div>
                                    }

                                </div>
                            </div>
                            <div className="verification-field">
                                <div className="verification-label medium" style={{marginBottom: '5px'}}>
                                    <Trans>Activation Code</Trans>
                                </div>
                                <div className="verification-activation">
                                    {
                                        Array(6).fill().map((object, index) => {
                                            return(
                                                <input id={"validation-" + index} disabled={! this.state.confirms.phone} className={this.state.confirms.activation ? "verification-success" : this.state.errors.activation ? "verification-error" : this.state.focus ? "active-input" : ""} onKeyDown={(e) => this.handleActivationInput(e, index)} onFocus={()=>this.toggleFocus(true)} onBlur={()=>this.toggleFocus(false)} maxLength="1" onPaste={this.pasteVerification} />
                                            )
                                        })
                                    }
                                    {
                                        this.state.confirms.activation ?
                                            <span style={{margin: "auto 10px"}}>{CheckIcon('fill-green')}</span>
                                        :
                                            null
                                    }
                                    {
                                        this.state.activation_loading ? 
                                            InLineLoading()
                                        :
                                            null
                                    }
                                </div>
                                {
                                    this.state.errors.activation ?
                                        <span style={{margin: "5px 0 0 0", fontSize: "8px", color: "red", display: "ruby-text"}}><Trans>*Activation code is invalid.</Trans></span>
                                    :
                                        null
                                }
                                
                            </div>
                        </div>
                    </div>
                    <div className="registration-actions">
                        {/*
                        <div className="registration-left">
                            <span className="primary medium">
                                <i className="fas fa-arrow-left" style={{marginRight: "20px"}}></i>
                                <span>Back</span>
                            </span>
                        </div>
                        */}
                        <div className="registration-right">
                            <span className="grey" style={{cursor: "pointer"}} onClick={() => {this.props.history.push("/registrationsuccess")}}><Trans>Skip for now</Trans></span>
                            <span onClick={this.goNext} className={"primary medium registration-button" + (this.state.confirms.phone && this.state.confirms.activation ? " registration-active" : "")} style={{marginLeft: "20px"}}>
                                <span><Trans>Next</Trans></span>
                                <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(MobileValidation);